import type { TechnicalDataScenario, TrScenarioApi } from "../model/types";

export const mapApiScenario = (scenario: TrScenarioApi): TechnicalDataScenario => ({
  dayNightFlushing: scenario.dayNightFlushing,
  detailedSimulationNeeded: scenario.detailed_simulation_needed,
  heatRecoveryEff: scenario.heat_recovery_eff,
  id: scenario.id,
  internalLoads: scenario.internal_loads,
  isDefault: scenario.is_default,
  measuredWeatherData: scenario.measured_weather_data,
  name: scenario.name,
  occupancy: scenario.occupancy,
  reactiveParameter: scenario.reactive_parameter,
  requiredTMax: scenario.requiredTMax,
  requiredTMin: scenario.requiredTMin,
  tryFile: scenario.try_file,
  tSupplyDynamic: scenario.t_supply_dynamic,
  weatherDataYear: scenario.weather_data_year,
});
